import { useTranslation } from 'react-i18next';

import aleaSidebarLogo from '../../../assets/img/png/logo/alea-sidebar-logo.png';
import minimizedAleaLogo from '../../../assets/img/svg/sidebar/minimized-logo.svg';

import { useAppSelector } from '../../../hook/useAppSelector';
import { DateFilter } from './DatePicker/DatePicker';
import { useAllFilters } from '../../../hook/useAllFilters';
import DesktopFilters from './Filters/DesktopFilters';
import SearchBar from '../Content/HealthMonitor/SearchBar/SearchBar';
import { useHeaderConfig } from '../../../hook/useHeaderConfig';
import GeoSummary from './GeoSummary/GeoSummary';
import CustomFilter from './Filters/CustomFilter';
import { useMenus } from '../../../hook/useMenus';
import { SearchExecutionMode } from '../../../enum/SearchExecutionMode';
import { IS_CLEAN_LAYOUT } from '../../../util/environment';

interface Props {
  title: string;
  icon: string;
}

const DesktopHeader: React.FC<Props> = ({ title, icon }) => {
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const filterType = useAppSelector((state) => state.globalFilters.filterType);

  const menus = useMenus();
  const headerConfig = useHeaderConfig(menus);

  const { t } = useTranslation();
  const { handleApplyAllFilters } = useAllFilters();

  return (
    <div className={`header ${isSidebarMinimized ? 'minimized' : ''}`}>
      <div className="logo">
        {!IS_CLEAN_LAYOUT && (
          <img src={isSidebarMinimized ? minimizedAleaLogo : aleaSidebarLogo} alt="aleaSidebarLogo" />
        )}
      </div>

      <div className="content">
        <span className="title page_title">
          <img src={icon} alt="hmTitlePulse" />
          {t(title)}
        </span>

        {headerConfig.datePicker && <DateFilter onSearch={handleApplyAllFilters} />}

        {headerConfig.search && <SearchBar hasSearchColumnDropdownPicker={false} mode={SearchExecutionMode.LIVE} />}

        {filterType && (
          <>
            <CustomFilter />
            {headerConfig.sumBy && <GeoSummary />}
          </>
        )}

        {filterType && <DesktopFilters />}
      </div>
    </div>
  );
};

export default DesktopHeader;
